const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    height: 30,
  },
  area: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  areaRight: {
    justifyContent: 'flex-end'
  },
  areaLeft: {
    justifyContent: 'flex-start'
  },
}

export default styles;


// WEBPACK FOOTER //
// ./src/components/Footer/styles.js